module.exports = __webpack_public_path__ + "img/N234-1-EN.79f3c2c1.png";